import { render, staticRenderFns } from "./CRUDProdutosInternos.vue?vue&type=template&id=f3660756&"
import script from "./CRUDProdutosInternos.vue?vue&type=script&lang=js&"
export * from "./CRUDProdutosInternos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports